















































































































































































import SalesCapacityLine from '@/components/product-management/SalesCapacityLine.vue';
import SwitchToggle from '@/components/SwitchToggle.vue';
import ErrorDialog from '@/components/dialog-box/ErrorDialog.vue';
import ConfirmDialog from '@/components/dialog-box/ConfirmDialog.vue';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Inject } from 'vue-typedi';
import { SerializationHelper } from '@/helpers/SerializationHelper';
import { ProductService } from '@/services/ProductService';
import { Product } from '@/model/product/Product';
import { SalesCapacity } from '@/model/product/SalesCapacity';
import { EventBus } from '@/helpers/EventBus';
import dayjs from 'dayjs';
import SnackBar from '@/components/Snackbar.vue';
import { Traceability } from '@/model/product/Traceability';
import { ZoneCodeConstants, ProductionTypeConstants } from '@/model/product/ProductConstants';
import { FishingOrigin } from '@/model/product/FishingOrigin';
import authentication from '@/configuration/authentication';
import { equals } from '@/helpers/ObjectsHelper';

@Component({
    components: { SalesCapacityLine, SwitchToggle, ErrorDialog, ConfirmDialog, SnackBar }
})
export default class ProductSettingsForm extends Vue {
    private static readonly DAYS_OF_WEEK: string[] = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];

    @Inject()
    productService!: ProductService;

    @Prop({ default: {} }) selectedProduct: Product;
    @Prop({ default: {} }) traceability: Traceability;

    public isDialogOpen: boolean = false;
    public showSnackBar: boolean = false;

    public FISHMONGER_ZONECODE: string = ZoneCodeConstants.FISHMONGER;

    public product: Product = null;
    public validationVisible: boolean = false;
    public isReturnDialogOpen: boolean = false;
    public isOutOfStockFeatureEnabled: boolean = (window as any).config ? (window as any).config.isOutOfStockFeatureEnabled : false;
    public dailyCapacity: SalesCapacity;

    private inputValidationMap: Map<String, boolean> = new Map();
    public canSave: boolean = true;
    public hasDelay: boolean = false;
    public isInStock: boolean = false;
    public selectedFishingArea: string = "";
    public subAreas: string[] = [];
    public hasErrorBreedingCountry: boolean = false;
    public hasErrorFishingTechnique: boolean = false
    public hasErrorFishingArea: boolean = false;
    public hasErrorFishingSubArea: boolean = false;
    public hasErrorScientificName: boolean = false;
    public hasErrorProductionMethod: boolean = false;
    public hasSaveError: boolean = false;

    public error: string = "";

    @Watch("selectedProduct", { deep: false, immediate: true })
    watchSelectedProduct() {
        if (!this.selectedProduct) {
            return;
        }
        this.product = SerializationHelper.toInstanceFromJsonObj(new Product(), this.selectedProduct);
        this.initSubAreas();
        this.populateProductOutOfStockStatus();
        this.checkDelay();
        this.checkStockActivated();
        this.initializeNullDelay();
        this.initializeNullFishingOrigin();
    }

    get hasError() {
        return this.error !== "";
    }

    get canDisplayStockButtons(): boolean {
        if (!this.product.isCateringService) {
            return true;
        }
        const userRights = authentication.userRights();
        return userRights &&
            userRights.role === 'CENTRAL_ADMIN';
    }

    get isProductionTypeSelected() {
        return this.product.fishingOrigin != null && this.product.fishingOrigin.productionType != null;
    }

    get isFishProduct() {
        return this.product.zoneCode === this.FISHMONGER_ZONECODE;
    }

    get isWildFishProduct() {
        return this.product.fishingOrigin.productionType === ProductionTypeConstants.WILD;
    }

    get isBreedingFishProduct() {
        return this.product.fishingOrigin.productionType === ProductionTypeConstants.BREEDING;
    }

    private initializeNullFishingOrigin() {
        if (this.product?.fishingOrigin != null) {
            this.product.fishingOrigin.breedingCountry ??= null;
            this.product.fishingOrigin.fishingArea ??= null;
            this.product.fishingOrigin.fishingSubArea ??= null;
            this.product.fishingOrigin.fishingTechnique ??= null;
            this.product.fishingOrigin.productionMethod ??= null;
            this.product.fishingOrigin.productionType ??= null;
            this.product.fishingOrigin.scientificName ??= null;
        } else {
            this.product.fishingOrigin = new FishingOrigin();
        }
    }

    private initSubAreas() {
        const fishingAreas = this.traceability?.fishingAreas;
        const fishingOrigin = this.product?.fishingOrigin;
        const fishingArea = fishingOrigin?.fishingArea;

        const foundFishingArea = fishingAreas?.find((area) => area.label === fishingArea);

        this.subAreas = foundFishingArea?.fishingSubAreas ?? [];

    }


    private checkDelay() {
        this.hasDelay = this.product.weeklyCapacity.some((capacity) => capacity.delay != null && capacity.delay > 0);
    }

    private checkStockActivated() {
        this.isInStock = this.product.weeklyCapacity.find((capacity) => capacity.isUnlimited === true || capacity.quantity > 0) != null;
    }

    private initializeNullDelay() {
        this.product.weeklyCapacity.forEach((capacity) => {
            if (capacity.delay == null) {
                capacity.delay = 0;
            }
        });
    }

    protected onFishingAreaChange(event: any): void {
        const selectedArea = this.traceability?.fishingAreas?.find(area => area.label === event.target.value);

        if (selectedArea != null) {
            this.subAreas = selectedArea.fishingSubAreas;
        }
    }

    private populateProductOutOfStockStatus() {
        const lastOutOfStockDate = this.product.lastOutOfStockDate;
        if (lastOutOfStockDate == null) {
            this.product.inStockToday = true;
            return;
        }

        const lastOutOfStockDateAsStr = dayjs(lastOutOfStockDate).format('YYYY-MM-DD');
        const todayAsStr = dayjs().format('YYYY-MM-DD');

        this.product.inStockToday = lastOutOfStockDateAsStr !== todayAsStr;
    }

    public get formattedLabel() {
        return this.product.cug + " - " + (this.product.label ? this.product.label : 'Libellé indisponible');
    }

    public showValidation() {
        this.validationVisible = true;

        setTimeout(() => { this.validationVisible = false }, 2000);
    }

    public saveChanges() {
        if (!this.canSave) {
            return;
        }
        this.canSave = false;

        if (!this.hasDelay) {
            this.product.weeklyCapacity.forEach((capacity) => {
                capacity.delay = 0;
            });
        }

        if (!this.isInStock) {
            this.product.weeklyCapacity.forEach((capacity) => {
                capacity.quantity = 0;
            });
        }

        if (this.product.isCateringService) {
          this.product.weeklyCapacity.forEach((capacity) => {capacity.delay = this.dailyCapacity.delay;})
        }

        this.checkFishingProductValidityAndNullifyWrongField();
        if (this.error !== "") {
            this.canSave = true;
            return;
        }

        this.productService.updateProduct(this.product).then((product: Product) => {
            this.showValidation();

            this.product = SerializationHelper.toInstanceFromJsonObj(new Product(), product);
            this.populateProductOutOfStockStatus();

            this.selectedProduct = SerializationHelper.toInstanceFromJsonObj(this.selectedProduct, this.product);

            this.canSave = true;
        }).catch((error) => {
            this.canSave = true;
            this.hasSaveError = true;
        });
        this.checkDelay();
        this.checkStockActivated();
    }

    closeErrorPopUp() {
        this.hasSaveError = false;
    }

    public checkFishingProductValidityAndNullifyWrongField() {
        this.resetErrors();
        if (this.product.fishingOrigin == null || this.product.fishingOrigin.productionType == null) {
            return;
        }

        if (this.product.fishingOrigin.breedingCountry == '' && this.product.fishingOrigin.fishingArea == '') {
            this.product.fishingOrigin = null;
            return;
        }

        const fishingOrigin = this.product.fishingOrigin;

        if (fishingOrigin.productionType === ProductionTypeConstants.BREEDING) {
            fishingOrigin.fishingArea = null;
            fishingOrigin.fishingSubArea = null;
            fishingOrigin.fishingTechnique = null;

            if (!fishingOrigin.breedingCountry) {
                this.hasErrorBreedingCountry = true;
            }
        }

        if (fishingOrigin.productionType === ProductionTypeConstants.WILD) {
            fishingOrigin.breedingCountry = null;

            if (!fishingOrigin.fishingArea) {
                this.hasErrorFishingArea = true;
            }
            if (!fishingOrigin.fishingSubArea) {
                this.hasErrorFishingSubArea = true;
            }
            if (!fishingOrigin.fishingTechnique) {
                this.hasErrorFishingTechnique = true;
            }
        }

        if (!fishingOrigin.scientificName) {
            this.hasErrorScientificName = true;
        }
        if (!fishingOrigin.productionMethod) {
            this.hasErrorProductionMethod = true;
        }

        if (this.hasErrors()) {
            this.error = "* Information(s) manquante(s)";
        }
    }

    private resetErrors() {
        this.hasErrorBreedingCountry = false;
        this.hasErrorFishingArea = false;
        this.hasErrorFishingSubArea = false;
        this.hasErrorFishingTechnique = false;
        this.hasErrorScientificName = false;
        this.hasErrorProductionMethod = false;

        this.error = "";
    }

    private hasErrors(): boolean {
        return (
            this.hasErrorBreedingCountry ||
            this.hasErrorFishingArea ||
            this.hasErrorFishingSubArea ||
            this.hasErrorFishingTechnique ||
            this.hasErrorScientificName ||
            this.hasErrorProductionMethod
        );
    }


    public openDialog() {
        this.isDialogOpen = true;
    }

    public onClickReturn() {
        if (!equals(this.selectedProduct, this.product)) {
            this.isReturnDialogOpen = true;
            return;
        }
        this.confirmReturn();
    }


    setProductActivated(isInStockActivated: boolean) {
        this.isInStock = isInStockActivated;
        if (!this.isInStock) {
            this.product.weeklyCapacity = this.buildOutOfStockWeeklyCapacity();
            return;
        }

        const isVanillaProductActivated = this.selectedProduct.weeklyCapacity.find((capacity) => capacity.isUnlimited === true || capacity.quantity > 0) != null;
        if (!isVanillaProductActivated) {
            this.product.weeklyCapacity = this.buildDefaultWeeklyCapacity();
            return;
        }

        this.product.weeklyCapacity = SerializationHelper.toArrayInstanceFromJsonObjArray(() => new SalesCapacity(), this.selectedProduct.weeklyCapacity);
    }



    setDelayActivated(isDelayActivated: boolean) {
        this.hasDelay = isDelayActivated;
    }

    get productLabel(): string {
        if (this.product.label == null) {
            return this.product.cug;
        }
        return this.product.label;
    }

    private buildDefaultWeeklyCapacity(): SalesCapacity[] {
        return ProductSettingsForm.DAYS_OF_WEEK.map((dayOfWeek) => {
            const capacity = new SalesCapacity();
            capacity.dayOfWeek = dayOfWeek;
            capacity.isUnlimited = true;
            capacity.delay = 0;
            return capacity;
        });
    }

    private buildOutOfStockWeeklyCapacity(): SalesCapacity[] {
        return ProductSettingsForm.DAYS_OF_WEEK.map((dayOfWeek) => {
            const capacity = new SalesCapacity();
            capacity.dayOfWeek = dayOfWeek;
            capacity.quantity = 0;
            capacity.isUnlimited = false;
            capacity.delay = 0;
            return capacity;
        });
    }

    public changeStatusToOutOfStock() {
        this.productService.updateProductOutOfStockStatus(this.product.zoneCode, this.product.cug).then((product: Product) => {
            EventBus.$emit(EventBus.UPDATE_PRODUCT_OUT_OF_STOCK_STATUS, {});
            this.selectedProduct = product;
        });
    }

    public handleConfirm() {
        this.changeStatusToOutOfStock();
        this.closeOutOfStockDialog();
        this.openSnackBar();
    }

    public closeOutOfStockDialog() {
        this.isDialogOpen = false;
    }

    public confirmReturn() {
        this.$emit("onReturnSearchPage");
        this.closeDialog();
    }

    public closeDialog() {
        this.isReturnDialogOpen = false;
    }

    openSnackBar() {
        this.showSnackBar = true;
    }

    onCapacityChange(payload: { dayOfWeek: string; isQuantityValid: boolean; isDelayValid: boolean }) {
        this.inputValidationMap.set(payload.dayOfWeek, payload.isQuantityValid && payload.isDelayValid);
        this.updateCanSave();
    }

    updateCanSave(): boolean {
        if (this.inputValidationMap.size === 0) {
            this.canSave = true;
            return;
        }
        const iter = this.inputValidationMap.values();

        let elem = iter.next();
        while (!elem.done) {
            if (!elem.value) {
                this.canSave = false;
                return;
            }

            elem = iter.next();
        }

        this.canSave = true;
        return;
    }

    getDailyCapacity(weeklyCapacity: SalesCapacity[]): SalesCapacity {
      this.dailyCapacity = weeklyCapacity.find((capacity) => capacity.dayOfWeek === dayjs().locale('en').format('dddd').toUpperCase());
      return this.dailyCapacity;
    }
}

